//TODO: maybe put this as a vuex module so that we get dependency graph for certain things?
import globals from './globals.js'
import * as d3 from 'd3'
import utils from './utils.js'

var maxHash = (n,arr) =>{
  var vals = Object.values(arr)
  if (d3.sum(vals)===0){ return utils.hashCode(n) }
  var maxid = vals.indexOf(Math.max(...vals))
  var out = Object.keys(arr)[maxid]
  return utils.hashCode(out)
}


class Node {
  constructor(){
    this.name=""
    this.parent = null
    this.column=-1
    this.index=-1
    this.waste_percentage=0.0
    this.waste_reference=""
    this.is_searched=false
    this.is_updown=false
    this.source_links = [] //array of refs
    this.target_links = [] //array of refs
    this.source_amts = {}
    this.sector_amts = {}
    this.tags={}
    globals.simple_sources.forEach( (name)=>{this.source_amts[name]=0} )
    globals.simple_sectors.forEach( (name)=>{this.sector_amts[name]=0} )
  }

  copyObject(o){
    //copy everything else (name...)
    Object.keys(o).forEach( (k)=> { this[k.toLowerCase()] = o[k] })
    this.name = this.name.toLowerCase()

    if (o.tags && (typeof o.tags == 'string' || o.tags instanceof String)){
      this.tags = o.tags.split(',')
      var tmptags = {}
      this.tags.forEach( (t) =>{

        t = t.trim()
        if(!t.length) return
        var bits = t.split(':')
        if (bits.length===1)
          tmptags[bits[0]]=0.
          else{
            tmptags[bits[0]]=parseFloat(bits[1])
          }
      })
      this.tags = tmptags

      if(d3.sum(Object.values(this.tags))>1.)
        console.log("TAGS SUM TO GREATER THAN 1")
    }

    if(this.tags===null || this.tags===""){
      this.tags = {}
    }

    /*
    globals.overheads.forEach( (o)=>{
      if(!this[o]){
        this[o]=0

        var oh = this[o].toString()
        var pieces = oh.split(';')
        if (pieces.length===1){
          this[o] = {'pct':parseFloat(oh),'distribution':{}}
        }else{
          var diz = {}
          var distribution = pieces.slice(1)
          distribution.forEach( (d) =>{
            var parts = d.split(":")
            if(parts.length!=2) console.log("FAILURE")
            diz[parts[0]]=parseFloat(parts[1])
          })
          var diz_fixup = {}
          var amt = d3.sum(Object.values(diz))
          if(amt > 1.) console.log("BAD DISTRIBUTION DATA")
          Object.keys(diz).forEach( (k) => { diz_fixup["produced and distributed "+k]=diz[k]})

          this[o]={'pct':parseFloat(pieces[0]),'distribution':diz_fixup}
        }
      }
    })
    */
  }

  tagNames(){
    return Object.keys(this.tags)
  }

  search_match(s){
    var named = this.name.toLowerCase().includes(s)
    this.tagNames().forEach( (t)=>{
      named |= t.toLowerCase().includes(s)
    })
    return named
  }

  maxSector(){
    return maxHash(this.name,this.sector_amts)
  }

  maxSource(){
    return maxHash(this.name,this.source_amts)
  }

  datasource(){
    if(this.column == 1 || this.column == 2)
      return ["EIA-MER"]
    return [utils.mode(this.source_links,(l)=>{return (l.dataSource) ? l.dataSource : "Unknown"})]
  }

  get_value() {
    var link_value = (link)=>{
      if(!link) return 0
      return link.value;
    }
    return Math.max(
      d3.sum(this.source_links,link_value),
      d3.sum(this.target_links,link_value)
    );
  }

  get_src_value() {
    var link_value = (link)=>{
      return link.value;
    }
    return d3.sum(this.source_links,link_value)
  }

  get_tgt_value() {
    var link_value = (link)=>{
      return link.value;
    }
    return d3.sum(this.target_links,link_value)
  }

  get_references(){
    var ss = utils.collect(this.source_links,'reference')
    ss.concat(utils.collect(this.target_links,'reference'))
    return ss.filter( (x,i,a) => a.indexOf(x) == i)
  }
}


//TODO: rewrite this using a reduce for because clean
function temp(children,f){
  var out = null
  children.forEach( (n)=>{
    var amts = n[f]
    if (!out)
      out = Object.assign({},amts)
    else{
      for (var key in amts){
        out[key]+=amts[key]
      }
    }
  })
  return out
}

class CompoundNode {
  constructor(nodes){
    this.index = -1
    this.children = nodes
    this.group_id=0
    this.y_position=0.0
    if(nodes!=null){
      nodes.forEach(n=>{n.parent = this})
    }
  }

  get is_reserves(){
    return this.children.reduce( (acc,cur)=>acc|=cur.is_reserves,false)
  }

  grouping_function(){
    if(this.name.includes("*waste")) return ()=>{return 8e29}
    var lossy=this.source_links.reduce( (acc,cur)=>{return acc||cur.is_loss},false  )
    lossy&=this.target_links.reduce( (acc,cur)=>{return acc||cur.is_loss},false  )
    if(lossy) return ()=>{return 8e9}
    if (this.name.includes("*energy services*")) return ()=>{return -9e29}
    if (this.name.includes("overhead")) return ()=>{return 8e7}
    return null
  }


  get source_links(){
    return utils.flatten(this.children,'source_links')
  }

  get source_amts(){
    return temp(this.children,'source_amts')
  }

  get sector_amts(){
    return temp(this.children,'sector_amts')
  }

  get target_links(){
    return utils.flatten(this.children,'target_links')
  }

  get name(){
    return this.children.map((c)=>{return c.name}).join(', ')
  }

  get names(){
    return this.children.map((c)=>{return c.name})
  }

  get column(){
    if (!this.children.length) return -1
    return d3.min(this.children,(n)=>{return n.column})
  }

  get is_searched(){
    var s = false
    this.children.forEach(n=>{s|=n.is_searched})
    return s
  }

  datasource(){
    return 'unknown'
    //return collect(this.children,'datasource')
  }

  maxSector(){
    return utils.mode(this.children,(n)=>{return n.maxSector()})
  }

  maxSource(){
    return utils.mode(this.children,(n)=>{return n.maxSource()})
  }
  /*
  get group_id(){
    return utils.mode(this.children,(n)=>{return n.group_id})
  }
  */


  get_tags(){
    return utils.flatten_exclusive_callable(this.children,'tagNames')
  }

  get_references(){
    var out = []
    this.children.forEach( (c) => {
      out = out.concat(c.get_references())
    })
    return out.filter( (x,i,a) => a.indexOf(x) == i)
  }

  get_value(){
    var o= utils.sum_callable(this.children,'get_value')
    return o
  }

  get_tgt_value(){
    return utils.sum_callable(this.children,'get_tgt_value')
  }

  get_src_value(){
    return utils.sum_callable(this.children,'get_src_value')
  }


  heights(){
    var outs = {}
    this.children.forEach( (n) => {
      var out = n.get_value()
      outs[n.index]= isNaN(out) ? 0 : out
    })
    return outs
  }

  scaled_heights(s){
    var outs = {}
    this.children.forEach( (n) => {
      var out = n.get_value()*s
      outs[n.index]= isNaN(out) ? 0 : out
    })
    return outs
  }

  relative_y_positions(){
    var outs = {}
    var hts = this.heights()
    var base = 0
    this.children.forEach( (n) => {
      outs[n.index] = base
      base+=hts[n.index]
    })

    return outs
  }

  scaled_value(state){
    return d3.sum(Object.values(this.scaled_heights(state.value_scale)))
  }

  bottom(state){
    return this.y_position + this.scaled_value(state)
  }


  get upstream(){
    return utils.flatten_exclusive(this.children,'upstream')
  }

  get downstream(){
    return utils.flatten_exclusive(this.children,'downstream')
  }
}

class Link {
  constructor(id,src,tgt,value=0.,ref="",loss=false){
    this.index = id
    this.source = src //obj_ref
    this.target = tgt //obj_ref
    this.value = value
    this.reference = ref
    this.is_loss = loss

    //this.isRelevant=false
    //this.inUpstream=false
    //this.inDownstream=false
  }
  /*
  constructor(l){
    Object.keys(l).forEach( (k)=> { this[k] = l[k] })
  }
*/
}

export default{
  Node, CompoundNode, Link
}



//////////////////
// WEBPACK FOOTER
// ./src/structures.js
// module id = null
// module chunks = 